import { Helmet } from 'react-helmet-async';

export function StructuredData() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "LodgingBusiness",
    "name": "Majesty Hostel",
    "image": "https://majestyhostel.com/og-image.jpg",
    "description": "Premium student accommodation offering luxury, comfort, and an exceptional living experience near campus in Koforidua, Ghana.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Near Maybeth Guest House, Rasta Down",
      "addressLocality": "Koforidua",
      "addressRegion": "Eastern Region",
      "addressCountry": "GH"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 6.0891,
      "longitude": -0.2595
    },
    "telephone": ["+233540670010", "+233244629601"],
    "email": "majestyhostel@gmail.com",
    "url": "https://majestyhostel.com",
    "priceRange": "$$",
    "amenityFeature": [
      {
        "@type": "LocationFeatureSpecification",
        "name": "24/7 Electricity",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Starlink WiFi",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "24/7 Security",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "24/7 Water Supply",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "CCTV Surveillance",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Recreation Facilities",
        "value": true
      }
    ],
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    },
    "sameAs": [
      "https://facebook.com/majestyhostel",
      "https://instagram.com/majestyhostel",
      "https://twitter.com/majestyhostel"
    ]
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://majestyhostel.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Facilities",
        "item": "https://majestyhostel.com#facilities"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Gallery",
        "item": "https://majestyhostel.com#gallery"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Contact",
        "item": "https://majestyhostel.com#contact"
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
}
